import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-section01',
  templateUrl: './section01.component.html',
  styleUrls: ['./section01.component.scss']
})

export class Section01Component implements OnInit {
  @Input() data;

  constructor() {
  }

  ngOnInit() {
  }

}
